import { mapState, mapGetters } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentMember: (state) => state.currentMember,
    onLock: (state) => state.onLock,
  }),
  ...mapGetters('auth', ['loggedIn', 'isDealer']),
};

export const menuComputed = {
  ...mapState('menu', {
    currentMenu: (state) => state.cachedMenu,
  }),
};

export const setComputed = {
  ...mapState('set', {
    currentLanguage: (state) => state.cachedLanguage,
  }),
};

export const brandComputed = {
  ...mapState('brand', {
    currentBrand: (state) => state.cachedBrand,
  }),
};

export const globalComputed = {
  ...mapState('global', {
    currentSetting: (state) => state.currentSetting
  }),
};

export const optionComputed = {
  ...mapState('option', {
    solutionCategory: (state) => state.currentOption['solution_category'],
    brand: (state) => state.currentOption['brand'],
    productCategory: (state) => state.currentOption['product_parent_category'],
    industryCategory: (state) => state.currentOption['industry_category'],
  })
}
